<script lang="ts">
	import { format } from 'svelte-i18n';
	//Design system components
	import {
		DoubleDeviceButton,
		DoubleDeviceButtonV2,
		type DeviceButtonV2PropsTypes,
		type DoubleDeviceButtonV2PropsTypes,
	} from '@Shelly/shelly-design-system';
	//Component
	import DirectionButton from './DirectionButton.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	let className = '';
	export { className as class };

	export let device: Device,
		statuses: VCInterfaceStatus[],
		isLoading = false,
		useV2Components = false;
	export let devBtnsV2Props: {
		deviceButtonV2?: Partial<DeviceButtonV2PropsTypes>;
		doubleDeviceButtonV2?: Partial<DoubleDeviceButtonV2PropsTypes>;
	} = {
		deviceButtonV2: { size: 's' },
		doubleDeviceButtonV2: { size: 's' },
	};
</script>

{#if useV2Components}
	<DoubleDeviceButtonV2
		id="double-button-window-cover-controller"
		aria-label={$format('button_label_close_open', { default: 'Close / Open' })}
		{isLoading}
		class={className}
		isActive={false}
		{...devBtnsV2Props.doubleDeviceButtonV2}
	>
		<DirectionButton
			deviceButtonV2Props={devBtnsV2Props.deviceButtonV2}
			{useV2Components}
			slot="buttonLeft"
			direction="open"
			{device}
			{statuses}
			bind:isLoading
		/>
		<DirectionButton
			deviceButtonV2Props={devBtnsV2Props.deviceButtonV2}
			{useV2Components}
			slot="buttonRight"
			direction="close"
			{device}
			{statuses}
			bind:isLoading
		/>
	</DoubleDeviceButtonV2>
{:else}
	<DoubleDeviceButton
		id="double-button-window-cover-controller"
		aria-label={$format('button_label_close_open', { default: 'Close / Open' })}
		{isLoading}
		class={className}
		isActive={false}
	>
		<DirectionButton slot="buttonLeft" direction="open" {device} {statuses} bind:isLoading />
		<DirectionButton slot="buttonRight" direction="close" {device} {statuses} bind:isLoading />
	</DoubleDeviceButton>
{/if}
